<div class="banner" style="background-image: url('assets/{{ bannerImage }}');">
  <div class="titleBar">
    <div class="logoArea">
      <yara-logo-kg *ngIf="showYaraLogo"  ></yara-logo-kg>
      <h1>Tankmix </h1>
    </div>
    <app-navigation
      [showLanguageChooser]="showLanguageChooser"
    ></app-navigation>
  </div>
</div>
